const parseFaqData = data => {
    if (!data?.length > 0) return []
  
    const allTerms = []
  
    data.forEach(item => {
      const terms = item.terms?.nodes
  
      if (terms?.length > 0) {
        const term = terms[0]
  
        allTerms.push(term)
      }
    })
  
    let termsFiltered = allTerms.filter(
      (term, index) =>
        allTerms.findIndex(termInner => termInner.slug === term.slug) === index
    )
  
    data.forEach(item => {
      const terms = item.terms?.nodes
  
      if (terms?.length > 0) {
        const term = terms[0]
  
        termsFiltered.forEach(termFiltered => {
          if (termFiltered.slug === term.slug) {
            const termIndex = termsFiltered.findIndex(
              termFilteredInner => termFilteredInner.slug === termFiltered.slug
            )
  
            termsFiltered[termIndex] = {
              ...termsFiltered[termIndex],
              data: [
                ...(termsFiltered[termIndex]?.data
                  ? termsFiltered[termIndex].data
                  : []),
                { title: item.title, content: item.content, category: term.slug },
              ],
            }
          }
        })
      }
    })
  
    return termsFiltered
  }
  
  export default parseFaqData;